import Vue from 'vue'
import Router from 'vue-router'
import land from '@/components/land/land'
import index from '@/components/index/index'
import store from '@/store'
Vue.use(Router)
// 基础路由（如登录页、404等）
const constantRoutes = [
  {
      path: '/land',
      name: 'land',
      component: land
  },
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/index',
    name: 'index',
    component: index
  }
  // {
  //   path: '/404',
  //   component: () => import('@/views/404'),
  //   hidden: true
  // }
]

const createRouter = () => new Router({
  // mode: 'history',
  routes: constantRoutes
})

const router = createRouter()

// 动态添加路由
export function addRoutes(routes) {
  let ary=routes.filter(t=>t.path.split('/').length>2 && t.type === 0).map(t=>t.path.split('/')[1])
  let parentRoutes =[...new Set(ary)]//去重
  const formatRoutes = parentRoutes.map(r => {
    const route = {
      path: `/${r}`,
      name: r,
      component: () => import(`@/components/${r}/index`),
      children: []
    }
    let children = routes.filter(t=>t.path.split('/').length>2 && t.path.indexOf('/'+r)>=0 && t.type === 0)
    
    if (children) {
      route.children = children.map(c => {
        let child = {
          path: c.path.replace('/'+r+'/',''),
          name: c.code,
          component: () => import(`@/components${c.path}`)
        }
        return child
      })
    }
    return route
  })
  router.addRoutes(formatRoutes)
}
router.beforeEach(async (to, from, next) => {
  console.log('router.beforeEach.to', to)
  if (to.path === '/land') {
    next()
  } 
  else {
    let hasToken=localStorage.getItem('accessToken')
    if (hasToken) {
      if (!store.state.permission.routes.length) {
        await store.dispatch('permission/generateRoutes')
        next({ ...to, replace: true })
      } 
      else {
        next()
      }
    } 
    else {
      next('/land')
    }
  }
})
export default router





// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'index',
//       component: index
//     },{
//       path: '/index',
//       name: 'index',
//       component: index
//     },{
//       path: '/land',
//       name: 'land',
//       component: land
//     },{
//       path: '/epReport/query',
//       name: 'epReport',
//       component: ()=>import('@/components/epReport/index'),
//       children:[
//         {
//           path: '/epReport/query',
//           name: 'epList',
//           component: () => import('@/components/epReport/epList')
//         },{
//           path: '/epReport/label',
//           name: 'eplabel',
//           component: ()=>import('@/components/epReport/label')
//         },{
//           path: '/epReport/reportData/ep',
//           name: 'examineEp',
//           component: ()=>import('@/components/epReport/examineEp')
//         },{
//           path: '/epReport/reportData/data',
//           name: 'examineData',
//           component: ()=>import('@/components/epReport/examineData')
//         },{
//           path: '/epReport/epLabelList',
//           name: 'epLabelList',
//           component: ()=>import('@/components/epReport/epLabelList')
//         },{
//           path: '/epReport/clue',
//           name: 'clue',
//           component: ()=>import('@/components/epReport/clue')
//         },{
//           path: '/epReport/epInfo',
//           name: 'epInfo',
//           component: ()=>import('@/components/epReport/epInfo')
//         },
//       ]
//     },{
//       path: '/resourcesList/econoItem',
//       name: 'resources',
//       component: ()=>import('@/components/resources/index'),
//       children:[
//         {
//           path: '/resourcesList/econoItem',
//           name: 'econoItem',
//           component: ()=>import('@/components/resources/econoItem')
//         },{
//           path: '/resourcesData/econoData',
//           name: 'econoData',
//           component: ()=>import('@/components/resources/econoData')
//         },{
//           path: '/resourcesList/maintain',
//           name: 'maintain',
//           component: ()=>import('@/components/resources/maintain')
//         },{
//           path: '/toExamine',
//           name: 'toExamine',
//           component: ()=>import('@/components/resources/toExamine')
//         },{
//           path: '/resourcesList/ecoIndustryItem',
//           name: 'ecoIndustryItem',
//           component: ()=>import('@/components/resources/ecoIndustryItem')
//         },{
//           path: '/resourcesData/ecoIndustryData',
//           name: 'ecoIndustryData',
//           component: ()=>import('@/components/resources/ecoIndustryData')
//         },
//         {
//           path: '/resourcesData/housePriceData',
//           name: 'housePriceData',
//           component: ()=>import('@/components/resources/housePriceData')
//         },{
//           path: '/resourcesData/workData',
//           name: 'workData',
//           component: ()=>import('@/components/resources/workData')
//         },{
//           path: '/resourcesData/productData',
//           name: 'productData',
//           component: ()=>import('@/components/resources/productData')
//         },
//         {
//           path: '/resourcesAnalysis/hiatus',
//           name: 'hiatusAnalysis',
//           component: ()=>import('@/components/resources/hiatusAnalysis')
//         }
//       ]
//     },{
//       path: '/userAnalysis',
//       name: 'service',
//       component: ()=>import('@/components/service/index'),
//       children:[
//         {
//           path: '/userAnalysis',
//           name: 'userAnalysis',
//           component: ()=>import('@/components/service/analysis')
//         },
//         {
//           path: '/user',
//           name: 'user',
//           component: ()=>import('@/components/service/user')
//         },
//         {
//           path: '/role',
//           name: 'role',
//           component: ()=>import('@/components/service/role')
//         },{
//           path: '/menu',
//           name: 'menu',
//           component: ()=>import('@/components/service/menu')
//         },{
//           path: '/vip/price',
//           name: 'vipPrice',
//           component: ()=>import('@/components/service/vipPrice')
//         },{
//           path: '/vip/order',
//           name: 'vipOrder',
//           component: ()=>import('@/components/service/vipOrder')
//         },{
//           path: '/wxManage/user',
//           name: 'wxUser',
//           component: ()=>import('@/components/service/wxUser')
//         },{
//           path: '/wxManage/vipPrice',
//           name: 'wxVipPrice',
//           component: ()=>import('@/components/service/wxVipPrice')
//         },{
//           path: '/wxManage/vipOrder',
//           name: 'wxVipOrder',
//           component: ()=>import('@/components/service/wxVipOrder')
//         },{
//           path: '/mpwxManage/user',
//           name: 'mpwxUser',
//           component: ()=>import('@/components/service/mpwxUser')
//         },{
//           path: '/mpwxManage/userAnalysis',
//           name: 'mpwxUserAnalysis',
//           component: ()=>import('@/components/service/mpwxUserAnalysis')
//         },{
//           path: '/promotion/user',
//           name: 'promotionUser',
//           component: ()=>import('@/components/service/promotionUser')
//         },{
//           path: '/journal/backstage',
//           name: 'journalBackstage',
//           component: ()=>import('@/components/service/journalBackstage')
//         },{
//           path: '/journal/BackstageLogin',
//           name: 'journalBackstageLogin',
//           component: ()=>import('@/components/service/journalLoginBackstage')
//         },{
//           path: '/journal/ioc',
//           name: 'journalIoc',
//           component: ()=>import('@/components/service/journalIoc')
//         },{
//           path: '/journal/eco',
//           name: 'journalEco',
//           component: ()=>import('@/components/service/journalEco')
//         },{
//           path: '/journal/ecoLogin',
//           name: 'journalEcoLogin',
//           component: ()=>import('@/components/service/journalLoginEco')
//         },{
//           path: '/journal/applet',
//           name: 'journalApplet',
//           component: ()=>import('@/components/service/journalApplet')
//         },{
//           path: '/journal/h5',
//           name: 'journalH5',
//           component: ()=>import('@/components/service/journalH5')
//         }
//       ]
//     },
//     // {
//     //   path: '/set',
//     //   name: 'set',
//     //   component: ()=>import('@/components/set/index'),
//     //   children:[
//     //     {
//     //       path: '/set/',
//     //       name: 'setReportItem',
//     //       component: ()=>import('@/components/set/setReportItem')
//     //     },{
//     //       path: '/getReport',
//     //       name: 'getReport',
//     //       component: ()=>import('@/components/set/getReport')
//     //     },{
//     //       path: '/reportList',
//     //       name: 'reportList',
//     //       component: ()=>import('@/components/set/reportList')
//     //     },
//     //   ]
//     // },
//     {
//       path: '/industryChainManagement/industryClass',
//       name: 'industryChain',
//       component: ()=>import('@/components/industrialChain/index'),
//       children:[
//         {
//           path: '/industryChainManagement/industryClass',
//           name: 'industryClass',
//           component: ()=>import('@/components/industrialChain/industryClass')
//         },
//         {
//           path: '/industryChainManagement/query',
//           name: 'query',
//           component: ()=>import('@/components/industrialChain/query')
//         },{
//           path: '/industryChainManagement/detail',
//           name: 'detail',
//           component: ()=>import('@/components/industrialChain/detail')
//         }
//       ]
//     },{
//       path: '/reportManage/class',
//       name: 'report',
//       component: ()=>import('@/components/report/index'),
//       children:[
//         {
//           path: '/reportManage/class',
//           name: 'reportIndustryClass',
//           component: ()=>import('@/components/report/class')
//         },
//         {
//           path: '/rankinglist/industryPopular',
//           name: 'industryPopular',
//           component: ()=>import('@/components/report/industryPopular')
//         },
//         {
//           path: '/reportLabel',
//           name: 'reportLabel',
//           component: ()=>import('@/components/report/reportLabel')
//         },{
//           path: '/rankinglist/query',
//           name: 'rankinglistquery',
//           component: ()=>import('@/components/report/rankinglist')
//         }
//         ,{
//           path: '/reportManage/query',
//           name: 'reportquery',
//           component: ()=>import('@/components/report/reportList')
//         },{
//           path: '/reportManage/comment',
//           name: 'reportcomment',
//           component: ()=>import('@/components/report/comment')
//         },{
//           path: '/reportManage/jobAnswer',
//           name: 'jobAnswer',
//           component: ()=>import('@/components/report/jobAnswer')
//         },{
//           path: '/reportManage/operAnalysis',
//           name: 'reportoperAnalysis',
//           component: ()=>import('@/components/report/operAnalysis')
//         },{
//           path: '/rankinglist/rankinglistReport',
//           name: 'rankinglistReport',
//           component: ()=>import('@/components/report/rankinglistReport')
//         },{
//           path: '/reportManage/info',
//           name: 'reportInfo',
//           component: ()=>import('@/components/report/info')
//         },{
//           path: '/articleList/query',
//           name: 'articlequery',
//           component: ()=>import('@/components/report/articleList')
//         },{
//           path: '/articleList/addArticle',
//           name: 'addArticle',
//           component: ()=>import('@/components/report/addArticle')
//         },{
//           path: '/articleList/corrOfArticle',
//           name: 'corrOfArticle',
//           component: ()=>import('@/components/report/corrOfArticle')
//         }
//       ]
//     },{
//       path: '/theme/setChart',
//       name: 'themeManage',
//       component: ()=>import('@/components/setChart/index'),
//       children:[
//         {
//           path: '/theme/setChart',
//           name: 'themeItem',
//           component: ()=>import('@/components/setChart/themeItem')
//         },
//         {
//           path: '/theme/list',
//           name: 'themeList',
//           component: ()=>import('@/components/setChart/themeList')
//         },
//         {
//           path: '/theme/comment',
//           name: 'themeComment',
//           component: ()=>import('@/components/setChart/themeComment')
//         },
//         {
//           path: '/theme/analysis',
//           name: 'themeAnalysis',
//           component: ()=>import('@/components/setChart/themeAnalysis')
//         }
//       ]
//     }

//   ]
// })


// WEBPACK FOOTER //
// ./src/router/index.js